/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量9
 * @export
 * @interface Col9
 */
export interface Col9 {
}

/**
 * Check if a given object implements the Col9 interface.
 */
export function instanceOfCol9(value: object): value is Col9 {
    return true;
}

export function Col9FromJSON(json: any): Col9 {
    return Col9FromJSONTyped(json, false);
}

export function Col9FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col9 {
    return json;
}

export function Col9ToJSON(json: any): Col9 {
    return Col9ToJSONTyped(json, false);
}

export function Col9ToJSONTyped(value?: Col9 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

